import script from "./UserFeedbackSubmitDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UserFeedbackSubmitDialog.vue?vue&type=script&setup=true&lang=js"

import "@/features/user/styles/operationArea/UserFeedbackSubmitDialog.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__